import { runningClientSide } from '@benzinga/utils';

export const elementIsVisibleInViewport = (el: HTMLElement, partiallyVisible = false): boolean => {
  if (!runningClientSide() || !el) {
    return false;
  }

  const { bottom, left, right, top } = el.getBoundingClientRect();
  const { innerHeight, innerWidth } = window;

  return partiallyVisible
    ? ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};
